import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'stringToTime'
})
export class StringToTimePipe implements PipeTransform {

  transform(value: number): string {
    
    const hora = Math.trunc(value / 10000);

    value = value - (hora * 10000);

    const minutos = Math.trunc(value / 100);
    const segundos = value - (minutos * 100);
    
    return `${hora}:${minutos.toString().padStart(2,'0')}:${segundos.toString().padStart(2,'0')}`;
  }

}
